import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ImageUploaderComponent} from './image-uploader/image-uploader.component';
import {FileDropDirective} from './file-drop.directive';

@NgModule({
  imports: [
    CommonModule
  ],
  exports: [
    ImageUploaderComponent
  ],
  declarations: [ImageUploaderComponent, FileDropDirective]
})
export class ImageUploaderModule {
}



// WEBPACK FOOTER //
// ./src/app/image-uploader/image-uploader.module.ts